"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateChoice = exports.translate = void 0;
var message_selector_1 = __importDefault(require("./message-selector"));
/**
 * Get a translated string
 *
 * @param {String} key The translation key
 * @param {Object} replacements A key/value set of string replacements
 * @return String
 */
exports.translate = function (key, replacements) {
    var message = getLine(key);
    if (replacements === undefined) {
        return message;
    }
    for (var replace in replacements) {
        message = message.split(':' + replace).join(replacements[replace]);
    }
    return message;
};
/**
 * Get a translated string determined by plurality
 *
 * @param {String} key The translation key
 * @param {Integer|Array} count The number of items to determine the plurality. Can also just be an array.
 * @param {Object} replacements A key/value set of string replacements
 * @return String
 */
exports.translateChoice = function (key, count, replacements) {
    replacements = typeof replacements !== 'undefined' ? replacements : {};
    // Add the count to the list of replacements. Allow users to pass an array to
    // be counted, which is a nicer syntax supported by Laravel's translator.
    count = Array.isArray(count) ? count.length : count;
    replacements.count = count;
    // Get the full translation. It will include all the piped plural versions, but with all replacements done.
    var message = exports.translate(key, replacements);
    return message_selector_1.default(message, count || 0, window.locale);
};
/**
 * Get a line from the supplied translation files
 * @param {String} key
 */
var getLine = function (key) {
    var translations = window.translations;
    return translations["*." + key]
        || translations[key]
        || translations["statamic::" + key]
        || translations["statamic::messages." + key]
        || key;
};
